import React, { Component } from 'react';
import cross from '../../../assets/images/close_popup.svg';
import arrow from '../../../assets/images/drpdwnArrow.svg';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { baseURL, serviceDeliveryBaseURL } from '../../../Services/config/apiGateway';
import { GETLOOKUPDATA_ENDPOINT, REQUESTERFIELDS_ENDPOINT } from '../../../Services/config/apiEndPoints';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../../css/manageServices/FieldsForRequester.css';
import message from '../../../data/Message.json';
import TitleDescription from '../../../data/TitleDescription.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure()
class FieldsForRequester extends Component {
    constructor(props) {
        super(props);
        this.container = React.createRef();
        this.state = {
            dropdownIndex: [],
            openDropdown: [],
            fieldsData: [],
            lookupData: [],
            lookupType: '',
            lookupCode: '',
            lookupCodeArr: [],
        }
    }
    ActionData = [{ name: "Empty Containers" }, { name: "Copper Cores and Concentrates" }]
    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
        ApiCall(
            'GET',
            serviceDeliveryBaseURL + REQUESTERFIELDS_ENDPOINT,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                ' x-cc-trace-id': '1234',
            },
        ).then((apiData) => {
            if (apiData.flag !== -1) {
                if (apiData.flag === 500) {
                    toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                }
                else {
                    console.log('I am 200!');
                    this.setState({ fieldsData: apiData });
                }
            } else {
                // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
            }
        });
        // LOOKUP API CALL
        ApiCall(
            'GET',
            baseURL + GETLOOKUPDATA_ENDPOINT, //+ `?lookupType=${datas.fieldLookup}`,
            {},
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-cc-trace-id': '1234',
            }
        ).then(data => {
            if (data.flag !== -1) {
                if (data.flag === 500) {
                    toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                }
                else {
                    console.log('I am 200!');
                    this.setState({ lookupData: data })
                }
            }
            else {
                // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
            }
        })
    }
    getDate = (dateString) => {
        //   split the date in order to get day, month and year separately and then use it in another constructor - Date(year, month, day)
        let dateParts = dateString.split("/");
        // month is 0-based, that's why we need dataParts[1] - 1
        let date = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]).toString();
        let day = date.split(' ')[2];
        let month = date.split(' ')[1];
        let year = date.split(' ')[3];
        return `${day}-${month}-${year}`;
    }
    toggleDropDown = (index) => {
        let dropdown = this.state.openDropdown;
        dropdown[index] = !this.state.openDropdown[index]
        let x = [...this.state.dropdownIndex];
        x.push(index)
        let fieldArray = this.state.lookupData.filter(name => name.lookupType === this.state.fieldsData[index].fieldLookup)
        this.setState({ openDropdown: dropdown, dropdownIndex: x, lookupCodeArr: fieldArray })
    }
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            let dropdownIndex = this.state.dropdownIndex.filter((element, i) => i === this.state.dropdownIndex.indexOf(element))
            for (let index = 0; index < dropdownIndex.length; index++) {
                const element = dropdownIndex[index];
                let a = this.state.openDropdown;
                a[element] = false;
                this.setState({ showEffectiveCalendarArray: a })
            }
        }
    };
    lookupCall = (index) => {
        let fieldArray = this.state.lookupData.filter(name => name.lookupType === this.state.fieldsData[index].fieldLookup)
        return fieldArray[0]?.lookupCode
    }
    render() {
        return (
            <div class="fieldaForRequestermodalcss" >
                <MetaDecorator title={TitleDescription.fieldsForRequesterPageTitle} description={TitleDescription.fieldsForRequesterPageDescription} />
                <div class="fieldaForRequestermodalcssin">
                    <div className='fieldaForRequestercross'>
                        <img src={cross} width="21" height="21" onClick={this.props.onClick} class="d-inline-block align-top" alt="" loading="lazy" />
                    </div>
                    <div class="fieldaForRequesterUpperDiv">
                        <small class="fieldaForRequesterModalHeading">
                            Fields For Requester
          </small>
                        {console.log(this.state.lookupData)}
                    </div>
                    <div>
                        <table className="fieldaForRequesterHeadingTable">
                            <tbody>
                                <tr>
                                    <td className="fieldaForRequesterHeadingText" id="fieldName">Field Name</td>
                                    <td className="fieldaForRequesterHeadingText" id="dropdownListing">Dropdown Listing</td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="allFieldaForRequesterData">
                            <table className="fieldsForRequesterDataTable">
                                <tbody>
                                    {
                                        this.state.fieldsData.map((data, index) =>
                                            <tr className="fieldsForRequesterbodyDetails">
                                                <td className="fieldsForRequesterData" id="dataFieldName">
                                                    {data.displayName}
                                                </td>
                                                <div className="dropdownListingDiv"
                                                    style={{ borderBottom: data.entryType !== "Free Text" ? "1px solid #979797" : "" }}
                                                >
                                                    <input readOnly className="fieldsForRequesterData" id="dataDropdownListing"
                                                        value={data.entryType === "Free Text" ? "NA" :
                                                            this.lookupCall(index)
                                                        }
                                                    />
                                                    {
                                                        data.entryType !== "Free Text" &&
                                                        <img class="dropdownIcon" src={arrow} alt="Second slide" onClick={() => this.toggleDropDown(index)} />}
                                                </div>
                                                {
                                                    this.state.openDropdown[index] &&
                                                    <div class="fieldsDropdownOuter" >
                                                        <div class="fieldsDropdownOutline" ref={this.container} >
                                                            {
                                                                this.state.lookupCodeArr.map((name, i) => {
                                                                    return (
                                                                        <table class='fieldsDropdownData'  >
                                                                            <td class="fieldsDropdownRow"
                                                                            >
                                                                                <small id="dropdownsText" >{name.lookupCode} </small>
                                                                            </td>
                                                                        </table>
                                                                    );
                                                                })
                                                            }
                                                        </div>
                                                    </div>}
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default FieldsForRequester;